"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IntegerInputWeb = ({ value, onChange, placeholder, maxValue }) => {
    const handleChange = (event) => {
        const inputValue = event.target.value;
        const parsedValue = parseInt(inputValue, 10);
        if (Number.isInteger(parsedValue) && parsedValue > 0 && parsedValue < maxValue) {
            onChange(parsedValue);
        }
        else {
            onChange(1); // Set value to 1 if it's not a positive integer
        }
    };
    return ((0, jsx_runtime_1.jsx)("input", { className: "integer-input", value: value || '', type: "number", placeholder: placeholder, onChange: handleChange }));
};
exports.default = IntegerInputWeb;
